import React from 'react';

/**
 * columns: [{ key, label, render?(row), className?, align? }]
 * align: 'right' | 'left' | 'center' — convenience for numeric columns instead of className.
 * rows: array of records
 * maxHeight: optional CSS max-height (e.g. '60vh'). When set, vertical AND
 * horizontal scrolling both happen on this one wrapper div — never nest an
 * outer overflow-y-auto div around <Table> instead, or the horizontal
 * scrollbar ends up pinned below all the rows instead of the visible
 * viewport (unreachable without scrolling all the way down first).
 */
const ALIGN_CLASS = { right: 'text-right', left: 'text-left', center: 'text-center' };

export default function Table({ columns, rows, loading, emptyText = 'No records found.', maxHeight, className = '' }) {
  return (
    <div
      className={`${maxHeight ? 'overflow-auto' : 'overflow-x-auto'} ${className}`}
      style={maxHeight ? { maxHeight } : undefined}
    >
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="sticky top-0 z-10 bg-gray-50">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className={`px-4 py-2.5 font-semibold text-gray-600 ${c.align ? ALIGN_CLASS[c.align] : 'text-left'} ${c.className || ''}`}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-8 text-center text-gray-400">
                Loading…
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-8 text-center text-gray-400">
                {emptyText}
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr key={row.id ?? i} className="hover:bg-gray-50">
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={`px-4 py-2.5 text-gray-700 ${c.align ? ALIGN_CLASS[c.align] : ''} ${c.className || ''}`}
                  >
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
